"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppActiveFeatures = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const molecules_1 = require("../../molecules");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const access_1 = require("@completeanatomy/access");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function AppActiveFeatures() {
    const isARKitCompatible = (0, device_1.useARKitCompatibilityStatus)();
    const isExportImageAvailable = (0, access_1.useUIElementAccess)('actionMenu', bridge_schema_1.UIRestrictableElement.ActionMenuExportImageButton);
    const buttons = [
        bridge_schema_1.PreferenceBoolOption.ShowTabs,
        bridge_schema_1.PreferenceBoolOption.ShowTools,
        bridge_schema_1.PreferenceBoolOption.ShowSaveScreenButton,
        bridge_schema_1.PreferenceBoolOption.ShowTipsPanel,
    ];
    if (isARKitCompatible) {
        buttons.splice(3, 0, bridge_schema_1.PreferenceBoolOption.ShowARPanel);
    }
    if (isExportImageAvailable) {
        buttons.push(bridge_schema_1.PreferenceBoolOption.ShowExportButton);
    }
    return ((0, jsx_runtime_1.jsx)(molecules_1.PreferencesSection, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.activeFeatures), subtitle: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.activeFeaturesSubtitle), "data-e2e": 'AppActiveFeatures_PreferencesSection', children: (0, jsx_runtime_1.jsx)(ButtonsContainer, { "data-e2e": 'AppActiveFeatures_ButtonsContainer', children: buttons.map(type => ((0, jsx_runtime_1.jsx)(molecules_1.AppFeatureButton, { type: type, "data-e2e": 'AppActiveFeatures_AppFeatureButton' }, type))) }) }));
}
exports.AppActiveFeatures = AppActiveFeatures;
const ButtonsContainer = styled_components_1.default.div `
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-bottom: 17px;
`;
